let cursor = null;

function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

if (!isTouchDevice()) {
    cursor = new MouseFollower();
}

export { cursor };
